(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uq-ai-disclosure"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('uq-ai-config');
    const dialog = document.getElementById('uq-ai-dialog');
    if (!config || !dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const demos = new Set((config.dataset.demoAssets || '').split(',').map(s => s.trim()).filter(Boolean));
    const marker = /\[(?:ai|ki)\]/ig;
    const entries = new Map();
    const markedImages = new WeakMap();
    let opener;
    let overflow;
    let frame;
    let pausedSwiper;
    function open(button) {
      if (dialog.open) return;
      opener = button;
      overflow = document.documentElement.style.overflow;
      const swiper = button.closest('.swiper')?.swiper;
      if (swiper?.autoplay?.running && typeof swiper.autoplay.stop === 'function') {
        pausedSwiper = swiper;
        swiper.autoplay.stop();
      }
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      dialog.querySelector('[data-uq-ai-close]').focus();
    }
    dialog.querySelectorAll('[data-uq-ai-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = overflow || '';
      if (pausedSwiper && !pausedSwiper.destroyed) pausedSwiper.autoplay.start();
      pausedSwiper = null;
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
    function tagged(image) {
      const alt = image.getAttribute('alt') || '';
      const hasMarker = /\[(?:ai|ki)\]/i.test(alt);
      const asset = (image.getAttribute('src') || '').split('?')[0].split('/').pop();
      if (hasMarker) {
        const description = alt.replace(marker, '').trim();
        image.alt = description ? description + ' – ' + config.dataset.altNote : config.dataset.altNote;
        markedImages.set(image, { asset, alt: image.alt });
      }
      const previous = markedImages.get(image);
      if (previous && (previous.asset !== asset || previous.alt !== image.alt)) markedImages.delete(image);
      return hasMarker || markedImages.has(image) || demos.has(asset);
    }
    function visible(image) {
      if (!image.isConnected || image.getBoundingClientRect().width < 60 || image.getBoundingClientRect().height < 60) return false;
      for (let node = image; node && node !== document.body; node = node.parentElement) {
        const style = getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) < .05) return false;
      }
      return true;
    }
    function update() {
      frame = null;
      entries.forEach((entry, image) => {
        if (!image.isConnected || !entry.host.isConnected) {
          entry.button.remove(); entries.delete(image); return;
        }
        const hidden = !tagged(image) || !visible(image);
        if (entry.button.hidden !== hidden) entry.button.hidden = hidden;
        if (hidden) return;
        const rect = image.getBoundingClientRect();
        const host = entry.host.getBoundingClientRect();
        const left = Math.round(rect.left - host.left + entry.host.scrollLeft + 12);
        const top = Math.round(rect.bottom - host.top + entry.host.scrollTop - 56);
        const position = `${left},${top}`;
        if (entry.position !== position) {
          entry.position = position;
          entry.button.style.left = `${left}px`; entry.button.style.top = `${Math.max(8, top)}px`;
        }
      });
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    function scan(root = document) {
      root.querySelectorAll('main img, product-modal img, quick-add-modal img').forEach(image => {
        if (!tagged(image) || entries.has(image)) return;
        let host = image.closest('.slideshow__slide, .swiper-slide, .card__inner, .product__media-item, .collection-hero__image-container, .image-with-text__media, .banner') || image.closest('picture')?.parentElement || image.parentElement;
        if (host?.tagName === 'A') host = host.parentElement;
        if (!host) return;
        if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'uq-ai-badge';
        button.textContent = config.dataset.badgeLabel;
        button.setAttribute('aria-label', config.dataset.openLabel);
        button.setAttribute('aria-haspopup', 'dialog'); button.setAttribute('aria-controls', dialog.id);
        button.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); open(button); });
        host.append(button); entries.set(image, { host, button });
        image.addEventListener('load', schedule);
        host.addEventListener('pointerenter', () => { schedule(); setTimeout(schedule, 320); });
        host.addEventListener('pointerleave', () => { schedule(); setTimeout(schedule, 320); });
        host.addEventListener('transitionend', schedule);
        resize.observe(host); resize.observe(image);
      });
      schedule();
    }
    const resize = new ResizeObserver(schedule);
    const observer = new MutationObserver(mutations => {
      if (mutations.some(mutation => mutation.type === 'childList' || (mutation.target.tagName === 'IMG' && ['alt', 'src'].includes(mutation.attributeName)))) scan();
      else schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['alt', 'src', 'class', 'style', 'hidden'] });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', () => scan());
    scan();
  })();
  } catch(e) { console.error(e); }
})();

})();
